import { render, staticRenderFns } from "./CreateBizBtn.vue?vue&type=template&id=75026b4d&lang=pug"
import script from "./CreateBizBtn.vue?vue&type=script&lang=js"
export * from "./CreateBizBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports